export default {
	methods: {
    // 下载标题和副标题图片
		downTitleImg(id) {
			return this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: id
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        return Promise.resolve(blobUrl)
      });
		},
    // 获取副标题html下的所有图片，然后获取id下载到本地在替换地址
    replaceImg(domId) {
      const dom = document.querySelectorAll(`[id=${domId}]`);
      if (!dom) return;
      const imgs = [...dom].map(item => [...item.querySelectorAll("img")]).flat();
      console.log(`${domId}-需要下载的图片`, imgs);
      for (const img of imgs) {
        ((el) => {
          let id;
          id = el.src.split("?fileId=")[1];
          if (id) {
            this.downTitleImg(id)
              .then(url => {
                this.$nextTick(() => {
                  el.src = url;
                  console.log(`${domId}-下载图片成功`, url);
                })
              }).catch(err => {
                console.error(`${domId}-下载图片失败`, err);
              });
          }
        })(img);
      }
    }
	},
  mounted() {
    setTimeout(() => {
      if (this.$route.name === "createItem") {
        this.replaceImg(`${this.type}-formateTitle`);
        this.replaceImg(`${this.type}-img`);
        this.replaceImg(`${this.type}-img1`);
      } else {
        this.replaceImg(`${this.question.type}-formateTitle`);
        this.replaceImg(`${this.question.type}-img`);
        this.replaceImg(`${this.question.type}-img1`);
      }
    }, 2000);
  },
}